module.exports = __webpack_public_path__ + "./fonts/StretchPro.otf";